<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          Log
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Log</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <b-row>
              <b-col>
                <strong>Log Detail ({{ model.id }})</strong>
                <span class="float-right">Date : {{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>Client Information</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover="" class="font-weight-bold">Attacker: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover="" v-if="model">
                        {{model.remote_addr ? model.remote_addr : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover class="font-weight-bold">
                        XFF:
                        <!-- <b-badge   v-if="model.xff" variant='success'>?</b-badge> -->
                        <span class="text-info">
                          <i style='cursor: pointer;' @click="info_xff = true" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        {{ model.xff ? model.xff : '-' }}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover class="font-weight-bold">Country: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_remote_addr" v-b-tooltip.hover>
                        <span v-if="model.country" class="flag-icon" :class="set_flag(model.country)"></span>
                        {{model.country ? model.country : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_protocol" v-b-tooltip.hover class="font-weight-bold">Protocol: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_protocol" v-b-tooltip.hover>
                        {{model.protocol ? model.protocol : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover class="font-weight-bold">Source port: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        -
                        <!-- {{model.protocol ? model.protocol : '-'}} -->
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover class="font-weight-bold">Method: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        {{model.method ? model.method : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>Server Information</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover class="font-weight-bold">Host(Domain:)</label>
                    </b-col>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover >{{model.host}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover class="font-weight-bold">Destination Port:</label>
                    </b-col>
                    <b-col>
                      -
                      <!-- <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label> -->
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">Victim:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model">{{model.target}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">Public:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_public ? model.agent.ip_addr_public : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">Private:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_private ? model.agent.ip_addr_private : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">WAS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.iwaf_type ? model.agent.iwaf_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">OS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.os_type ? model.agent.os_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">host:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.host ? model.agent.host : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="model.agent && model.agent.nickname != model.agent.host">
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover class="font-weight-bold">Name:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.nickname ? model.agent.nickname : '-'}}</label>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label for="ph_uri" v-b-tooltip.hover>
                        URI <small>:</small>
                        <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                          {{view_split_uri ? 'split' : 'origin'}} view
                        </b-button>
                      </label>
                    </b-col>
                    <b-col>
                      <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                      <pre v-else>{{split_uri(model.uri || '')}}</pre>
                    </b-col>
                  </b-row> -->

                </div>
              </b-col>
              <b-col md="6" style="border-left: 1px solid #dcdcdc;">
                <h4>
                  Threat Information
                  <Bell v-if="model.message && model.message.messages && model.message.messages.length > 1" style="display: inline-block" :size="20" :count="model.message.messages.length" />
                </h4>

                <hr>
                <div>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" for="ph_response" v-b-tooltip.hover>Response(Action):</label>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">BlockMode</b-badge>
                      <b-badge v-else variant="warning">DetectMode</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="cursor:pointer"  @click="info_risk = true" md="3">
                      <label for="ph_response" v-b-tooltip.hover class="font-weight-bold">Risk:</label>
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.severity == 0" variant="danger">Emergency</b-badge>
                      <b-badge v-else-if="model.severity == 1" variant="danger">Alert</b-badge>
                      <b-badge v-else-if="model.severity == 2" variant="danger">Critical</b-badge>
                      <b-badge v-else-if="model.severity == 3" variant="warning">Error</b-badge>
                      <b-badge v-else-if="model.severity == 4" variant="warning">Warning</b-badge>
                      <b-badge v-else-if="model.severity == 5" variant="info">Notice</b-badge>
                      <b-badge v-else-if="model.severity == 6" variant="info">Info</b-badge>
                      <b-badge v-else variant="dark">Not recognized</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>Policy  ID:</label>
                    </b-col>
                    <b-col>
                      {{ model.m_id ? model.m_id : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover class="font-weight-bold">Policy Name:</label>
                    </b-col>
                    <b-col>
                      {{ policy_domain() ? policy_domain() : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover>
                        <label class="font-weight-bold">Message:</label>
                      </label>
                    </b-col>
                    <b-col>
                      <strong>{{ i18n_msessage() || '-' }}</strong>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label v-b-tooltip.hover>CVE</label>
                    </b-col>
                    <b-col>
                      {{ '-' }}
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>Tags:</label>
                    </b-col>
                    <b-col>
                      <span v-for="x in tags()">
                        {{ x || '-' }} <br>
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="parser_request">
              <b-col md="12">
                <b-form-group>
                  <b>
                    <label for="ph_request" v-b-tooltip.hover>
                      Request<small>:</small>
                    </label>
                    <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </b>
                  <pre class="bg-secondary" v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                  <pre v-else class="bg-secondary">{{split_uri(model.request || '')}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr v-if="has_get_parameter()">
            <b-row v-if="has_get_parameter()">
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>Request</label><br></b>
                  <pre class="p-4 rounded" v-b-tooltip.hover>{{model.request}}</pre>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b><label v-b-tooltip.hover>Request Parameter</label><br></b>
                  <table>
                    <thead>
                      <th class="border border-dark p-2">Name</th>
                      <th class="border border-dark p-2">Value</th>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in parameter()" v-bind:key="index">
                        <td class="p-2">
                          {{x.key}}
                        </td>
                        <td class="p-2">
                          {{x.value}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>Request Headers</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : 'no have data'}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <center>
              Matched Information
              <span class="float-right">
                <span class="text-danger">*</span>
                Available options in the current policy ({{ model.target }}})
              </span>
            </center>
            <hr>
            <table v-if="is_error" class="table table-sm table-dark">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Message</th>
                  <th scope="col">Rule ID</th>
                  <!-- <th scope="col">Maturity</th>
                  <th scope="col">Accuracy</th> -->
                  <th scope="col">Response</th>
                  <th scope="col">Risk</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <th scope="col" colspan="5">
                    The raw data was wrong, need to checking support
                  </th>
                </tr>
              </tbody>
            </table>
            <table v-else class="table table-sm table-dark text-center">
              <thead>
                <tr>
                  <th scope="col" rowSpan="2">#</th>
                  <th scope="col" rowSpan="2">Detect Position info</th>
                  <th scope="col" rowSpan="2">Message</th>
                  <th scope="col" rowSpan="2" @click="info_threat = true" style="cursor:pointer">
                    Threat
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <!-- <th scope="col" rowSpan="2">Maturity</th>
                  <th scope="col" rowSpan="2">Accuracy</th> -->
                  <!-- <th scope="col" rowSpan="2">Response</th> -->
                  <!-- <th scope="col" rowSpan="2">Risk</th> -->
                  <th v-if="!only_view" scope="col">Manage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                  <th scope="row">{{index + 1}}</th>
                  <th scope="row" style="cursor:pointer;" @click="base_policy(row.details.match)">
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                    {{row.value }}
                  </th>
                  <th scope="row">
                    {{ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['EN'] : row.message }}
                  </th>
                  <th scope="row">
                    <!-- <p>Policy ID : {{row.details.ruleId}} </p> -->
                    <span>{{row.details.ruleId}} </span>
                    <br>
                    <span>
                      <!-- Response: -->
                      <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                      <b-badge v-else-if="row.is_detect == 0" variant="danger">Block</b-badge>
                      <b-badge v-else variant="warning">Detect</b-badge>
                    </span>
                    <br>
                    <span>
                      <!-- Risk: -->
                      <span scope="row" v-if="row.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 1"><b-badge variant="danger">Alert</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 2"><b-badge variant="danger">Critical</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 3"><b-badge variant="warning">Error</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 4"><b-badge variant="warning">Warning</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 5"><b-badge variant="info">Notice</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 6"><b-badge variant="info">Info</b-badge></span>
                      <span scope="row" v-else><b-badge variant="dark">Not recognized</b-badge></span>
                    </span>
                  </th>
                  <!-- <th scope="row">{{row.details.maturity}}</th>
                  <th scope="row">{{row.details.accuracy}}</th> -->
                  <!-- <th>
                    <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                    <b-badge v-else-if="row.is_detect == 0" variant="danger">Block</b-badge>
                    <b-badge v-else variant="warning">Detect</b-badge>
                  </th> -->


                  <th v-if="!only_view && !loading" scope="row">
                    <b-btn
                      block
                      @click=" exception_info = { applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_add = true; exception_info_modal_remove = false"
                      size="sm"
                      variant="warning">
                        <span v-if="row.is_domain && !row.is_exception_domain" style="font-size:1.2rem; padding:0px; margin:0px;" class="text-danger">*</span>
                        Policy ({{ row.details.ruleId }}) Off
                      </b-btn>
                    <b-btn
                      block
                      @click=" exception_info = { applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_remove = true; exception_info_modal_add = false"
                      size="sm"
                      class="btn-addition"
                      variant="success">
                        <span v-if="row.is_domain && row.is_exception_domain" style="font-size:1.2rem;" class="text-danger">*</span>
                        Policy ({{ row.details.ruleId }}) On
                      </b-btn>
                  </th>
                </tr>
              </tbody>
            </table>
            <hr>

            <b-button v-if="!id" size="sm" class="float-right" @click="list">List</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- result modal -->
      <b-modal size="m" title="Risk : Threat description"  class="modal-info" v-model="info_risk" hide-footer @ok="info_risk = false">
        <p>
          <b-badge variant="danger">Emergency</b-badge> :
          Use when emergency situations need to be caused according to the Anomaly Score of inbound attack and outbound leak.
        </p>
        <p>
          <b-badge variant="danger">Alert</b-badge> :
          Use when alerting is required based on the association status between inbound attack and outbound web application level error.
        </p>
        <p>
          <b-badge variant="danger">Critical</b-badge> :
          AnomalyScore=5. Used for attack detection in critical situations at the highest level that can be caused by web attack detection rules, regardless of other detection situations.
        </p>
        <p>
          <b-badge variant="warning">Error</b-badge> :
          AnomalyScore=4.Used mostly by outbound runoff rules
        </p>
        <p>
          <b-badge variant="warning">Warning</b-badge> :
          Anomaly Score=3 Used by Malicious Client Detection Rules
        </p>
        <p>
          <b-badge variant="info">Notice</b-badge> :
          AnomalyScore=2.Use if you do not comply with protocol rules or have an unusual reference.
        </p>
        <p>
          <b-badge variant="info">Info</b-badge> :
          Other informational data will be displayed.

        </p>
        <p>
          <b-badge variant="dark">Not recognized</b-badge> : It's a risk that's not classified.
        </p>
      </b-modal>
      <!-- result modal -->
      <b-modal size="m" title="Description of detect"  class="modal-info" v-model="info_base_policy.is_show" hide-footer @ok="info_base_policy.is_show = false">
        provide detailed basis information for
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason}}
        </pre>
      </b-modal>
      <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-info" v-model="info_xff" hide-footer @ok="info_xff = false">
        XFF: Displayed when proxy is set to X-Forwarded-For
      </b-modal>
      <b-modal size="l" title="To set policy unused (exception)"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
        Do you want to apply {{exception_policy_id}} jacks as exceptions?
        <!-- <hr>
        * {{ruleI18n[exception_policy_id] ? ruleI18n[exception_policy_id]['KO'] : exception_policy_name }} -->
        <hr>
        <!-- This Policy({{exception_policy_id}}) applies to "{{exception_policy_name}}" by exception ? -->
        <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="exception_info.applied.indexOf(x) > -1">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <hr>
        <small>* Please select a policy target to apply</small>
      </b-modal>
      <b-modal size="m" title="Enable policy use (delete exceptions)"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
        applied exception policy({{exception_policy_msg}}) remove on "{{exception_policy_name}} policy"?
        <br>
        It is detected or blocked depending on the firewall mode
        <hr>
        <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in exception_info.applied" v-bind:key="index" :value="x" >{{x}}</b-form-checkbox>
        </b-form-checkbox-group>
        <hr>
        <!-- applied exception policy({{exception_policy_msg}}) remove on "{{exception_policy_name}} policy"? -->
      </b-modal>
      <b-modal size="m" title="Threat"  class="modal-info" v-model="info_threat" hide-footer @ok="info_threat = false">
        [Policy ID] ex) 920320
        <br>
        [Response] ex) Block
        <br>
        [Risk] ex) Notice
      </b-modal>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
